var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 89C50.5 71.4 67 55.6402 67 36.2C67 16.7596 52.2254 1 34 1C15.7746 1 1 16.7596 1 36.2C1 55.6402 17.5 71.4 34 89Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 49.8903C41.8114 49.8903 48.1431 43.3241 48.1431 35.2237C48.1431 27.1235 41.8114 20.557 34.0003 20.557C26.1892 20.557 19.8574 27.1235 19.8574 35.2237C19.8574 43.3241 26.1892 49.8903 34.0003 49.8903Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLogo);
export default __webpack_public_path__ + "static/media/locationLogo.7277b3f4e1170926540e8f7f035d2f4b.svg";
export { ForwardRef as ReactComponent };